import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";

function AddAllocatedCenterForm() {
  const classes = useStyles();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [subjectName, setSubjectName] = useState("");
  const [selectedCenter, setSelectedCenter] = useState("");
  const [centerId, setCenterId] = useState("");
  const [centerName, setCenterName] = useState("");
  const [centerCode, setCenterCode] = useState("");
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [slotCapacities, setSlotCapacities] = useState({});
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [center, setCenter] = useState([]);
  const [slot, setSlot] = useState([]);
  const [slotWiseSchedule, setSlotWiseSchedule] = useState("");
  const [centerAddress, setCenterAddress] = useState("");
  const [slotWiseScheduling, setSlotWiseScheduling] = useState("");
  const [maximumScheduling, setMaximumScheduling] = useState("");
  const [capacityPerShift, setCapacityPerShift] = useState("");
  const [tcaName, setTcaName] = useState("");
  const [tcaNumber, setTcaNumber] = useState("");

  const handleClose = () => {
    navigate("/admin/allocatedcenter");
  };

  const handleCenterChange = (event, value) => {
    if (value) {
      setSelectedCenter(value);
      setCenterId(value?.id);
      console.log("selected center", value.id); // Log directly from value
    } else {
      setSelectedCenter(null);
      setCenterId('');
    }
  };

  // const handleSlotChange = (event, newValue) => {
  //     setSelectedSlots(newValue.map((slot) => slot.id));
  //   };

  // const handleSlotChange = (event, newValue) => {
  //   const selectedIds = newValue.map((slot) => slot.id);
  //   setSelectedSlots(selectedIds);

  //   // Preserve existing capacities or add default (empty) ones
  //   const updatedCapacities = { ...slotCapacities };
  //   selectedIds.forEach((id) => {
  //     if (!updatedCapacities[id]) {
  //       updatedCapacities[id] = '';
  //     }
  //   });

  //   // Clean up removed slots
  //   Object.keys(updatedCapacities).forEach((id) => {
  //     if (!selectedIds.includes(Number(id))) {
  //       delete updatedCapacities[id];
  //     }
  //   });

  //   setSlotCapacities(updatedCapacities);
  // };

  const handleSlotChange = (event, newValue) => {
    const selectedIds = newValue.map((slot) => slot.id);
    setSelectedSlots(selectedIds);

    const updatedCapacities = { ...slotCapacities };

    selectedIds.forEach((id) => {
      if (!updatedCapacities[id]) {
        updatedCapacities[id] = ''; // Default empty
      }
    });

    // Remove deselected slots
    Object.keys(updatedCapacities).forEach((id) => {
      if (!selectedIds.includes(Number(id))) {
        delete updatedCapacities[id];
      }
    });

    setSlotCapacities(updatedCapacities);
  };

  const handleCapacityChange = (slotId, value) => {
    setSlotCapacities((prev) => ({
      ...prev,
      [slotId]: value,
    }));
  };


  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const fetchStates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStates(data.states);
      } else {
        console.error("Failed to fetch categories data");
      }
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    fetchStates();
  }, []);

  const fetchDistricts = async (selectedStateId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state/${selectedStateId}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setDistricts(data.cities);
      } else {
        console.error("Failed to fetch categories data");
      }
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    if(selectedStateId){
      fetchDistricts(selectedStateId);
    }
  }, [selectedStateId]);

  const fetchCenter = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setCenter(response.data.center);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  const fetchSlot = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/centers_slot`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setSlot(response.data.centers_slot);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchSlot();
  }, []);

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setSelectedStateId(value.id);

    setSelectedDistrict(null);
    setSelectedDistrictId(null);
  };
  const handleDistrictChange = (event, value) => {
    setSelectedDistrict(value);
    setSelectedDistrictId(value.id);
  };

  const formattedSlots = selectedSlots.map((id) => ({
    slot_id: id,
    capacity: Number(slotCapacities[id]),
  }));

  const handleFormSubmit = () => {

    if (!centerId?.toString().trim()) {
      toast.warn("Please select Branch.");
      return;
    }
    if (!centerName?.trim()) {
      toast.warn("Please add Center Name.");
      return;
    }
    if (!centerCode?.trim()) {
      toast.warn("Please add Center Code.");
      return;
    }
    if (!centerAddress?.trim()) {
      toast.warn("Please add Center Address.");
      return;
    }
    if (!selectedState?.toString().trim()) {
      toast.warn("Please select State.");
      return;
    }
    if (!selectedDistrict?.toString().trim()) {
      toast.warn("Please select City.");
      return;
    }
    if (!tcaName?.trim()) {
      toast.warn("Please add TCA Name.");
      return;
    }
    if (!tcaNumber?.trim()) {
      toast.warn("Please add TCA Number.");
      return;
    }
    if (tcaNumber.trim().length < 10) {
      toast.warn("TCA Number should not be less than 10 digits.");
      return;
    }
    if (!capacityPerShift?.toString().trim()) {
      toast.warn("Please add Capacity Per Shift.");
      return;
    }
    if (!maximumScheduling?.toString().trim()) {
      toast.warn("Please add Maximum Scheduling.");
      return;
    }
    //   if (!slotWiseSchedule?.trim()) {
    //     toast.warn("Please select Slot Scheduling.");
    //     return;
    //   }
    //   if (slotWiseSchedule === "yes" && selectedSlots.length === 0) {
    //     toast.warn("Please select slots.");
    //     return;
    //   }
    //   if (
    //   slotWiseSchedule === "yes" &&
    //   selectedSlots.length !== 0 &&
    //   selectedSlots.some((id) => !slotCapacities[id]?.toString().trim())
    // ) {
    //   toast.warn("Please add capacity for all selected slots.");
    //   return;
    // }

    const data = {
      allocated_centers: {
        center_name: centerName,
        center_code: centerCode,
        center_address: centerAddress,
        tca_name: tcaName,
        tca_mobile_number: tcaNumber,
        capacity_per_shift: capacityPerShift,
        max_scheduling: maximumScheduling,
        // slot_wise_scheduling: slotWiseSchedule,
        Center_id: centerId,
        city_id: selectedDistrictId,
        state_id: selectedStateId,
        // slots: formattedSlots,
      },
    };

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/add`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const res = response.data;

        if (res.success) {
          toast.success(res.message || "Center successfully");
          navigate("/admin/allocatedcenter");
        } else {
          toast.error(res.message || "Something went wrong");
        }
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.message || "Something went wrong. Please try again."
        );
      });
  };
  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h71vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite}  ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
               Center Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w25}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  id="center-autocomplete"
                  options={center || []}
                  value={selectedCenter}
                  onChange={handleCenterChange}
                  disableClearable
                  getOptionLabel={(option) => option?.center_name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Branch"
                      variant="outlined"
                      {...params}
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w25}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Center Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setCenterName(e.target.value)}
                  value={centerName}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Center Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w25}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Center Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setCenterCode(e.target.value)}
                  value={centerCode}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Center code"
                />
              </div>

            </div>

            <div
              className={` ${classes.mt1}`}
            >
              <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                >

                </Typography>

                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1}
                             ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Address <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    value={centerAddress}
                    onChange={(e) => setCenterAddress(e.target.value)}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Enter Address"
                    multiline
                    rows={6}
                  />
                </div>
              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>

                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
                          ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    State <span className={classes.textcolorred}>*</span>
                  </FormLabel>

                  <Autocomplete
                    id="state-autocomplete"
                    options={states || []}
                    value={selectedState}
                    onChange={handleStateChange}
                    disableClearable
                    getOptionLabel={(option) => option.name}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select State"
                        variant="outlined"
                        {...params}
                      />
                    )}
                    selectOnFocus
                    openOnFocus
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w37}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    City <span className={classes.textcolorred}>*</span>
                  </FormLabel>

                  <Autocomplete
                    options={districts || []}
                    id="district_id"
                    value={selectedDistrict}
                    onChange={handleDistrictChange}
                    disableClearable
                    getOptionLabel={(option) => option.name}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select City"
                        variant="outlined"
                        {...params}
                      />
                    )}
                  />
                </div>


              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    TCA Name <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    onChange={(e) => setTcaName(e.target.value)}
                    value={tcaName}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Enter TCA Name"
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w37}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    TCA Mobile Number <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value) && value.length <= 10) {
                        setTcaNumber(e.target.value)
                      }
                    }}
                    value={tcaNumber}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Enter TCA Mobile Number"
                  />
                </div>

              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Capacity Per Shift <span className={classes.textcolorred}>*</span>
                  </FormLabel>

                  <TextField
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setCapacityPerShift(e.target.value)
                      }

                    }}
                    value={capacityPerShift}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Enter Capacity "
                  />
                </div>
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w37}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Maximum Scheduling <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    onChange={(e) => {
                       const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                         setMaximumScheduling(e.target.value)
                      }}
                    }
                    value={maximumScheduling}
                    type="text"
                    variant="outlined"
                    required
                    placeholder="Enter Max Schedules"
                  />
                </div>


              </div>
              {/* <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>

                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Slot Wise Scheduling{" "}

                    <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <RadioGroup
                    className={`${classes.radiocolor}`}
                    row
                    aria-label="Slot Wise Scheduling"
                    name="Slot Wise Scheduling"
                    value={slotWiseScheduling}
                    onChange={(e) =>
                      setSlotWiseScheduling(e.target.value)
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          onClick={() => setSlotWiseSchedule("yes")}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          onClick={() => setSlotWiseSchedule("no")}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </div>
                {slotWiseSchedule === "yes" ?
                  <>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w10}`}
                    >
                    </div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w37}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Select Slot <span className={classes.textcolorred}>*</span>
                      </FormLabel>

                      <Autocomplete
                        multiple
                        id="tags-standard"
                        options={slot}
                        getOptionLabel={(option) => option.slot_name}
                        value={slot.filter((sub) =>
                          selectedSlots.includes(sub.id)
                        )}
                        onChange={handleSlotChange}
                        disableClearable
                        forcePopupIcon={false}
                        renderInput={(params) => (
                          <TextField
                            name="section"
                            type="text"
                            variant="outlined"
                            placeholder="Type to pick..."
                            {...params}
                          />
                        )}
                      />
                    </div>

                  </>
                  :
                  <>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                    >
                    </div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                    >
                    </div>
                  </>
                }
              </div>
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} ${classes.w100}`}
              >
                <Typography
                  className={`${classes.w35} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>

<div className={`${classes.gridLayoutOfInputs} `}>
                {slotWiseSchedule === "yes" && selectedSlots?.length !== 0 ?
                  <>

                 {selectedSlots.map((slotId) => {
  const slotLabel = slot.find((s) => s?.id === slotId)?.slot_name || `Slot ${slotId}`;
  return (
    <div
      key={slotId}
      className={`${classes.w100}`}
    >
      <FormLabel
        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
      >
        {slotLabel} Capacity <span className={classes.textcolorred}>*</span>
      </FormLabel>
      <TextField
        type="number"
        variant="outlined"
        required
        value={slotCapacities[slotId] || ''}
        onChange={(e) => handleCapacityChange(slotId, e.target.value)}
        placeholder={`Enter ${slotLabel} Capacity`}
      />
    </div>
  );
})}


                  </>
                  :
                  <>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                    >
                    </div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                    >
                    </div>
                  </>
                }
                </div>
              </div> */}
            </div>
          </div>

          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddAllocatedCenterForm;
